/* Theme default: winning Pick your pasta mobile CTA. */
(function () {
  'use strict';

  var KEY = '__petesThemeStickyBuybox';
  if (window[KEY] && typeof window[KEY].destroy === 'function') window[KEY].destroy();

  function init() {

  var handles = new Set([
    'penne', 'elbows', 'rotini', 'variety-s', 'spaghetti', 'linguine',
    'fettuccine', 'variety-spagheti', 'lasagna', 'no-carb-spaghetti',
    'variety', 'gnocchi', 'gnocchi-pro', 'gnocchi-keto', 'gnocchi-lite'
  ]);
  var match = location.pathname.match(/^\/products\/([^/]+)\/?$/);
  var root = document.querySelector('[data-simple-pdp]');
  if (!match || !handles.has(decodeURIComponent(match[1])) || !root) return;

  var ID = 'petes-sticky-buybox';
  var SPACER_ID = 'petes-sticky-buybox-spacer';
  document.getElementById(ID)?.remove();
  document.getElementById(SPACER_ID)?.remove();

  var bar = document.createElement('aside');
  bar.id = ID;
  bar.className = 'petes-sticky-buybox';
  bar.setAttribute('aria-hidden', 'true');
  var copy = document.getElementById('petes-sticky-buybox-script');
  bar.innerHTML =
    '<button id="petes-mobile-sticky-cta" class="petes-sticky-buybox__button" type="button">Pick your pasta</button>' +
    '<div class="petes-sticky-buybox__social">' +
      '<img width="72.001" height="11" alt="" aria-hidden="true" src="data:image/svg+xml;base64,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">' +
      '<span>4.7 stars | 1M+ Packs sold</span>' +
    '</div>';
  var spacer = document.createElement('div');
  spacer.id = SPACER_ID;
  spacer.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  document.body.appendChild(spacer);
  var button = bar.querySelector('button');
  if (copy) {
    button.textContent = copy.dataset.buttonLabel;
    bar.querySelector('.petes-sticky-buybox__social span').textContent = copy.dataset.socialProof;
  }
  button.tabIndex = -1;

  var media = window.matchMedia('(max-width: 767px)');
  var resizeObserver = null;
  var mutationObserver = null;
  var aliaObserver = null;
  var raf = 0;
  var destroyed = false;
  var watched = [];
  var focusTarget = null;
  var focusAddedTabindex = false;

  function visible(el) {
    if (!el || !el.isConnected || !el.getClientRects().length || el.closest('[hidden]')) return false;
    var style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function shapeTarget() {
    var selectors = [
      '.pdp-bundle__shape-gridwrap',
      '[data-pdpb-shape-select]',
      '.simple-pdp__shape-label-row',
      '.simple-pdp__shape-grid'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var node = root.querySelector(selectors[i]);
      if (visible(node)) return node;
    }
    return root.querySelector('#simple-pdp-buy-box, [data-simple-form]');
  }

  function headerHeight() {
    var group = document.querySelector('body > .sticky');
    var header = group || document.querySelector('.section-header, header');
    return visible(header) ? Math.min(window.innerHeight, Math.max(0, header.getBoundingClientRect().bottom)) : 0;
  }

  function overlayOpen() {
    if (document.body.classList.contains('pdp-lb-open')) return true;
    var menu = document.querySelector('mobile-menu');
    if (visible(menu)) return true;
    var header = document.querySelector('header[aria-expanded="true"]');
    if (header) return true;
    var cartDialog = document.querySelector('#cart-drawer [aria-modal="true"]');
    if (visible(cartDialog)) return true;
    var aliaPopup = document.querySelector('#alia-root-305875 [id^="alia-popup-root-"]:not(#alia-popup-root-alia-loqzmubmewuq2vod)');
    if (visible(aliaPopup)) return true;
    var otherDialog = document.querySelector('[role="dialog"][aria-modal="true"], dialog[open]');
    return visible(otherDialog);
  }

  function update() {
    raf = 0;
    if (destroyed) return;
    var target = shapeTarget();
    var form = root.querySelector('#simple-pdp-buy-box, [data-simple-form]');
    var builder = root.querySelector('[data-pdpb-builder]');
    var show = media.matches && visible(target) && !overlayOpen();
    if (show) {
      var end = target.getBoundingClientRect().bottom;
      [form, builder].forEach(function (el) {
        if (visible(el)) end = Math.max(end, el.getBoundingClientRect().bottom);
      });
      var viewportTop = headerHeight();
      // Only offer the return shortcut after all purchase controls have passed.
      show = end <= viewportTop;
    }
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    button.tabIndex = show ? 0 : -1;
    spacer.style.height = media.matches ? Math.ceil(bar.getBoundingClientRect().height) + 'px' : '0px';
    watchTargets(target, form, builder);
  }

  function schedule() {
    if (!destroyed && !raf) raf = requestAnimationFrame(update);
  }

  function watchTargets(target, form, builder) {
    if (!resizeObserver) return;
    var next = [target, form, builder, document.querySelector('body > .sticky'), bar].filter(Boolean);
    if (next.length === watched.length && next.every(function (el, i) { return watched[i] === el; })) return;
    resizeObserver.disconnect();
    next.forEach(function (el) { resizeObserver.observe(el); });
    watched = next;
  }

  function scrollToShape() {
    var target = shapeTarget();
    if (!visible(target)) return;
    var top = window.scrollY + target.getBoundingClientRect().top - headerHeight() - 12;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    clearFocusTabindex();
    focusTarget = target;
    focusAddedTabindex = !target.hasAttribute('tabindex');
    if (focusAddedTabindex) target.setAttribute('tabindex', '-1');
    target.addEventListener('blur', clearFocusTabindex, { once: true });
    target.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    schedule();
  }

  function clearFocusTabindex() {
    if (!focusTarget) return;
    focusTarget.removeEventListener('blur', clearFocusTabindex);
    if (focusAddedTabindex) focusTarget.removeAttribute('tabindex');
    focusTarget = null;
    focusAddedTabindex = false;
  }

  function destroy() {
    destroyed = true;
    if (raf) cancelAnimationFrame(raf);
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', schedule);
    document.removeEventListener('click', schedule, true);
    document.removeEventListener('keyup', schedule, true);
    media.removeEventListener('change', schedule);
    button.removeEventListener('click', scrollToShape);
    if (resizeObserver) resizeObserver.disconnect();
    if (mutationObserver) mutationObserver.disconnect();
    if (aliaObserver) aliaObserver.disconnect();
    clearFocusTabindex();
    bar.remove();
    spacer.remove();
    if (window[KEY] && window[KEY].destroy === destroy) delete window[KEY];
  }

  window[KEY] = { destroy: destroy };
  button.addEventListener('click', scrollToShape);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('click', schedule, true);
  document.addEventListener('keyup', schedule, true);
  media.addEventListener('change', schedule);
  if ('ResizeObserver' in window) resizeObserver = new ResizeObserver(schedule);
  if ('MutationObserver' in window) {
    // Alia mounts asynchronously and replaces its launcher with the full popup.
    aliaObserver = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.target instanceof Element && (
          record.target.closest('#alia-root-305875') ||
          Array.from(record.addedNodes).some(function (node) { return node instanceof Element && node.id === 'alia-root-305875'; })
        );
      })) schedule();
    });
    aliaObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var cart = document.getElementById('cart-drawer');
    if (cart) mutationObserver.observe(cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-modal', 'class'] });
    var menu = document.querySelector('mobile-menu');
    if (menu) mutationObserver.observe(menu, { attributes: true, attributeFilter: ['class', 'aria-expanded'] });
    var header = document.querySelector('header');
    if (header) mutationObserver.observe(header, { attributes: true, attributeFilter: ['aria-expanded'] });
  }
  schedule();
  }

  if (document.readyState === 'loading') {
    function onReady() { delete window[KEY]; init(); }
    window[KEY] = {
      destroy: function () {
        document.removeEventListener('DOMContentLoaded', onReady);
        if (window[KEY] === this) delete window[KEY];
      }
    };
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    init();
  }
})();

